import { whiteColor, infoBoxShadow, infoColor } from '../global';

const ListSeminarRegisteredManagermentStyle = (theme) => ({
    wrapper: {
        backgroundColor: (props) => props?.screen_background_color || whiteColor,
        minHeight: '200px',
    },
    sliderFirst: {
        margin: 'auto',
        height: 'auto',
        borderRadius: '8px',
        ...infoBoxShadow,
        borderColor: infoColor,
        textAlign: 'center',
        display: 'flex',
        padding: 0,
        marginTop: 20,
        marginBottom: '20px',
    },
    dataText: {
        fontWeight: '400',
    },
    spacing: {
        padding: '8px 0 0 20%',
        [theme.breakpoints.down('xs')]: {
            padding: '8px 0',
        },
    },
    btnStyle: {
        fontSize: 14,
        minWidth: '100px',
        margin: '10px',
    },
    buttonExit: {
        marginBottom: '50px',
    },
    leftContent: {
        height: 'auto',
    },
    preView: {
        width: '100%',
        padding: '20px 0',
    },
});

export default ListSeminarRegisteredManagermentStyle;
